import React, {useState} from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import { message} from 'antd'
import AddressListing from 'components/shared/AddressListing'
import Link from 'components/shared/Link'
import Heading from 'components/shared/Heading'
import Query from 'components/shared/Query'
import Button from 'components/shared/Button'
import './index.scss'

export const deleteWebOrderMutation = gql`
  mutation DeleteWebOrder($input: DeleteInput!) {
    DeleteWebOrder(input: $input) {
      deletedId
    }
  }
`

export const webOrdersQuery = gql`
  query Estates {
    viewer {
      id
      webOrders(last: 10) {
        edges {
          node {
            id
            estateId
            segment {
              id
              backgroundColor
              iconUrl
            }
            address {
              id
              street
            }
          }
        }
      }
    }
  }
`

const WebOrders = () => {
  const [isDeleting, setIsDeleting] = useState([])

  const onDeleteWebOrder = (mutation, webOrderId, refetch) => {
    setIsDeleting((isDeleting) => [...isDeleting, webOrderId])

    return mutation({
      variables: {
        input: {
          id: webOrderId,
        },
      }
    }).then((...res) => {
      message.success('Bestillingen ble slettet')
      setIsDeleting((isDeleting) => isDeleting.filter(id => id !== webOrderId))
      refetch()
    }).catch(err => {
      message.error('En feil oppstod ved sletting av Bestillingen. Vennligst forsøk på nytt eller kontakt EFKT kundeservice.')
      setIsDeleting((isDeleting) => isDeleting.filter(id => id !== webOrderId))
      refetch()
    })
  }

  return (
    <section className="webOrders">
      <Heading>Påbegynte oppdrag</Heading>
      <Query
        inlineError
        inlineLoading
        query={webOrdersQuery}
      >
        {({getData, loading, refetch}) => {
          const webOrders = (getData('viewer.webOrders.edges') || []).map(edge => edge.node)

          return (
            <Mutation mutation={deleteWebOrderMutation}>
              {(deleteWebOrder) => (
                webOrders.map(webOrder => {
                  const isDeletingOrder = isDeleting.includes(webOrder.id)
                  return (
                    <AddressListing
                      link={`/bestilling/${webOrder.id}`}
                      key={webOrder.id}
                      segment={webOrder.segment}
                      address={webOrder.address.street}
                      actions={(
                        <>
                          <Link to={`/bestilling/${webOrder.id}`}>
                            <Button type="navigation">Fortsett bestilling</Button>
                          </Link>
                          <Button
                            secondary
                            type="action"
                            onClick={onDeleteWebOrder.bind(null, deleteWebOrder, webOrder.id, refetch)}
                            disabled={isDeletingOrder}
                          >
                            {isDeletingOrder ? 'Sletter...' : 'Slett bestilling'}
                          </Button>
                        </>
                      )}
                    />
                )})
              )}
            </Mutation>
          )
        }}
      </Query>
    </section>
  )
}

export default WebOrders
